import { render, staticRenderFns } from "./InOutStock.vue?vue&type=template&id=28d2bce0&scoped=true&"
import script from "./InOutStock.vue?vue&type=script&lang=js&"
export * from "./InOutStock.vue?vue&type=script&lang=js&"
import style0 from "./InOutStock.vue?vue&type=style&index=0&id=28d2bce0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d2bce0",
  null
  
)

export default component.exports